import { create } from "zustand"

export type VehicleOverviewData = Partial<{
    plateId: string
    initialRegistration: Date
    mileAge: number
    vin: string
    description: string
}>

type FormStore = {
    vehicleData?: VehicleOverviewData
    setVehicleData: (values: VehicleOverviewData) => void
}

export const useVehicleOVerviewStore = create<FormStore>((set) => ({
    vehicleData: undefined,
    setVehicleData: (values) => set({ vehicleData: values }),
}))
